export interface IPresentationState {
  isModalOpen: boolean
}

export const initialState = (): IPresentationState => {
  return {
    isModalOpen: false
  }
}
